import { Controller } from "@hotwired/stimulus";

/**
 * Controller for permission groups with "Select All" functionality.
 * Each permission group can be toggled on/off as a whole.
 */
export class GroupedPermissionController extends Controller {
  static targets = ["selectAll", "permission"];

  connect() {
    this.updateSelectAllState();
  }

  toggleAll(event) {
    const isChecked = event.target.checked;
    this.permissionTargets.forEach((checkbox) => {
      if (!checkbox.disabled) {
        checkbox.checked = isChecked;
      }
    });
  }

  updateSelectAllState() {
    if (!this.hasSelectAllTarget) return;

    const enabledCheckboxes = this.permissionTargets.filter(
      (cb) => !cb.disabled
    );
    const checkedCount = enabledCheckboxes.filter((cb) => cb.checked).length;

    if (checkedCount === 0) {
      this.selectAllTarget.checked = false;
      this.selectAllTarget.indeterminate = false;
    } else if (checkedCount === enabledCheckboxes.length) {
      this.selectAllTarget.checked = true;
      this.selectAllTarget.indeterminate = false;
    } else {
      this.selectAllTarget.checked = false;
      this.selectAllTarget.indeterminate = true;
    }
  }

  permissionChanged() {
    this.updateSelectAllState();
  }
}
